import { TTreeViewModel } from '../services/models/CourseViewModels';

export interface IPreviewPageOption {
  id: number;
  depth: number;
  label: string;
}

function resolvePageTitle(page: TTreeViewModel): string {
  return page.data.title.value?.trim() || page.data.name?.trim() || `Page ${page.id}`;
}

function collectPageOptions(pages: TTreeViewModel[], depth = 0): IPreviewPageOption[] {
  return pages.flatMap((page) => {
    const current = {
      id: Number.parseInt(page.id, 10),
      depth,
      label: resolvePageTitle(page),
    };

    const children = page.children?.length ? collectPageOptions(page.children, depth + 1) : [];
    return [current, ...children];
  });
}

export function flattenPreviewPages(pages: TTreeViewModel[] | undefined): IPreviewPageOption[] {
  if (!pages?.length) {
    return [];
  }

  return collectPageOptions(pages);
}

export function findPreviewPageLabel(pages: TTreeViewModel[] | undefined, pageId?: number | null): string {
  if (!pages?.length || !pageId) {
    return 'Course';
  }

  const options = flattenPreviewPages(pages);
  return options.find((option) => option.id === pageId)?.label ?? `Page #${pageId}`;
}
